import Vue from 'vue'
import { session, localRead } from '@/libs/util'
import { getAuthUserParam } from '@/api/routers'

export default {
  state: {
    // 权限参数-日期修改
    authParameterPaymentDate: {
      // 收银修改单据日期-限制天数
      updateConsumptionPaymentDate: 1,
      // 充值修改单据日期-限制天数
      updateRechargePaymentDate: 1,
      // 卖卡修改单据日期-限制天数
      updateSellPaymentDate: 1,
      // 卖疗程修改单据日期-限制天数
      updateTreatmentPaymentDate: 1,
      // 退疗程修改单据日期-限制天数
      updateTreatmentRetreatPaymentDate: 1
    },
    // 权限参数-服务人员修改
    authParameterPersonDate: {
      // 收银修改服务人员日期-限制天数
      updateConsumptionPersonDate: 30,
      // 充值修改服务人员日期-限制天数
      updateRechargePersonDate: 30,
      // 卖卡修改服务人员日期-限制天数
      updateSellPersonDate: 30,
      // 卖疗程修改服务人员日期-限制天数
      updateTreatmentPersonDate: 30
    },
    // 权限参数-查询日期
    authParameterSearchDate: {
      // 收银查询日期-限制天数
      searchConsumptionDate: 2,
      // 充值查询日期-限制天数
      searchRechargeDate: 2,
      // 卖卡查询日期-限制天数
      searchSellDate: 2,
      // 卖疗程查询日期-限制天数
      searchTreatmentDate: 2,
      // 退疗程查询日期-限制天数
      searchTreatmentRetreatDate: 2
    },
    // 权限参数-销售人员业绩比例
    authParameterAchievementRatio: {
      // 收银-销售人员业绩比例
      consumptionAchievementRatio: 1,
      // 充值-销售人员业绩比例
      rechargeAchievementRatio: 1,
      // 卖卡-销售人员业绩比例
      sellAchievementRatio: 1,
      // 卖疗程-销售人员业绩比例
      treatmentAchievementRatio: 1
    },
    // 权限参数-修改（重录、支付方式）单据
    authParameterRerecordDate: {
      // 收银-重录单据
      consumptionRerecordDate: 1,
      // 充值-重录单据
      rechargeRerecordDate: 1,
      // 卖卡-重录单据
      sellRerecordDate: 1,
      // 疗程-重录单据
      treatmentRerecordDate: 1,
      // 卖疗程-重录单据
      treatmentRetreatRerecordDate: 1
    },
    // 权限参数-补开赠卡日期
    authParameterGiveCardDate: {
      // 充值-补开赠卡日期
      rechargeGiveCardDate: 0,
      // 卖卡-补开赠卡日期
      sellGiveCardDate: 0
    },
    // 权限逻辑-卖卡逻辑、字段
    authSellOrder: {
      // 卖卡-是否可开赠卡
      sellIsGiftCard: false,
      // 卖卡-开赠卡总金额是否大于赠卡应增金额
      sellIsGiftCardAmount: false,
      // 卖卡-是否能修改单据备注
      sellIsUpdateRemarks: false,
      // 卖卡-是否能修改赠送金额
      sellIsUpdateGiveAmount: false,
      // 卖卡-是否能修改储值金额
      sellIsUpdateVipAmount: false,
      // 卖卡-是否能修改标准金额
      sellIsUpdateNormalAmount: false,
      // 卖卡-是否储值金额--应收金额一致
      sellIsUpdateVipAmountAndPayAmount: false,
      // 卖卡-是否任意金额卖任意卡类
      sellIsRandomAmountUpgradeCardType: false,
      // 卖卡-是否输入会员卡密码
      sellIsSavePassword: false,
      // 卖卡-是否输入手机验证码
      sellIsSaveCode: false
    },
    // 权限逻辑-充值逻辑、字段
    authRechargeOrder: {
      // 充值-是否可开赠卡
      rechargeIsGiftCard: false,
      // 充值-是否能修改单据备注
      rechargeIsUpdateRemarks: false,
      // 充值-是否还款金额能大于欠款金额
      rechargeIsVipAmountAndArrearsAmount: false,
      // 充值-是否充值金额--应收金额一致
      rechargeIsUpdateVipAmountAndPayAmount: false,
      // 充值-是否可充值任意金额
      rechargeIsRandomAmount: false,
      // 充值-是否任意金额升级任意卡类
      rechargeIsRandomAmountUpgradeCardType: false,
      // 充值-开赠卡总金额是否大于赠卡应增金额
      rechargeIsGiftCardAmount: false,
      // 充值-是否输入会员卡密码
      rechargeIsSavePassword: false,
      // 充值-是否输入手机验证码
      rechargeIsSaveCode: false
    },
    // 权限逻辑-收银逻辑、字段
    authConsumptionOrder: {
      // 收银-是否可开添加会员卡备注
      consumptionIsAddVipRemarks: false,
      // 收银-是否可开修改会员卡备注
      consumptionIsUpdateVipRemarks: false,
      // 收银-是否能修改标准价格
      consumptionIsUpdatePrize: false,
      // 收银-是否能修改折扣
      consumptionIsUpdateDiscount: false,
      // 收银-是否能修改实际收入金额
      consumptionIsUpdateAmount: false,
      // 收银-是否修改会员卡密码
      consumptionIsUpdatePassword: false,
      // 收银-是否输入会员卡密码
      consumptionIsSavePassword: false,
      // 收银-是否输入会员卡手机号验证码
      consumptionIsSaveCode: false,
      // 收银-修改密码-是否输入会员卡手机号验证码
      consumptionUpdatePwdIsSaveCode: false
    },
    // 权限逻辑-疗程逻辑、字段
    authTreatmentOrder: {
      // 疗程-是否可开修改备注
      treatmentIsUpdateRemarks: false,
      // 疗程-是否能修改标准价格
      treatmentIsUpdatePrize: false,
      // 疗程-是否能修改应收金额
      treatmentIsUpdateDiscount: false,
      // 疗程-是否输入会员卡密码（会员）
      treatmentIsSavePassword: false,
      // 疗程-是否输入手机验证码（非会员）
      treatmentIsSaveCode: false
    },
    // 权限逻辑-退疗程逻辑、字段
    authTreatmentRetreatOrder: {
      // 退疗程-是否能修改实际金额
      treatmentRetreatIsUpdateActualAmount: false,
      // 退疗程-是否可开修改备注
      treatmentRetreatIsUpdateRemarks: false,
      // 退疗程-是否输入会员卡密码
      treatmentRetreatIsSavePassword: false
    },
    // 权限逻辑-会员卡列表逻辑、字段
    authMemberCardShowPhone: {
      // 会员卡列表-是否加密手机号
      memberCardListShowPhone: false,
      // 会员卡详情-是否加密手机号
      memberCardParticularsShowPhone: false
    },
    // 权限逻辑-会员列表逻辑、字段
    authMemberShowPhone: {
      // 会员列表-是否加密手机号
      memberListShowPhone: false,
      // 会员详情-是否加密手机号
      memberParticularsShowPhone: false,
      // 会员详情-是否输入手机验证码
      memberParticularsIsSaveCode: false
    },
    // 权限逻辑-会员分析
    authMemberAnalysisShowPhone: {
      // 会员分析列表-是否加密手机号
      memberAnalysisListShowPhone: false
    },
    // 权限参数-会籍管理-修改日期限制
    authParameterVipUpdateDate: 1,
    // 权限参数-基础设置-门店资料-可修改门店电话
    authParameterShopUpdatePhone: 1,
    // 权限参数-基础设置-门店资料-可修改门店在门店分布图中是否显示
    authParameterShopUpdateMapShow: 1
  },
  mutations: {
    setUpdateConsumptionPaymentDate (state, data) {
      state.authParameterPaymentDate.updateConsumptionPaymentDate = data
    },
    setUpdateRechargePaymentDate (state, data) {
      state.authParameterPaymentDate.updateRechargePaymentDate = data
    },
    setUpdateSellPaymentDate (state, data) {
      state.authParameterPaymentDate.updateSellPaymentDate = data
    },
    setUpdateTreatmentPaymentDate (state, data) {
      state.authParameterPaymentDate.updateTreatmentPaymentDate = data
    },
    setUpdateTreatmentRetreatPaymentDate (state, data) {
      state.authParameterPaymentDate.updateTreatmentRetreatPaymentDate = data
    },
    setUpdateConsumptionPersonDate (state, data) {
      state.authParameterPersonDate.updateConsumptionPersonDate = data
    },
    setUpdateRechargePersonDate (state, data) {
      state.authParameterPersonDate.updateRechargePersonDate = data
    },
    setUpdateSellPersonDate (state, data) {
      state.authParameterPersonDate.updateSellPersonDate = data
    },
    setUpdateTreatmentPersonDate (state, data) {
      state.authParameterPersonDate.updateTreatmentPersonDate = data
    },
    setSearchConsumptionDate (state, data) {
      state.authParameterSearchDate.searchConsumptionDate = data
    },
    setSearchRechargeDate (state, data) {
      state.authParameterSearchDate.searchRechargeDate = data
    },
    setSearchSellDate (state, data) {
      state.authParameterSearchDate.searchSellDate = data
    },
    setSearchTreatmentDate (state, data) {
      state.authParameterSearchDate.searchTreatmentDate = data
    },
    setSearchTreatmentRetreatDate (state, data) {
      state.authParameterSearchDate.searchTreatmentRetreatDate = data
    },
    setConsumptionAchievementRatio (state, data) {
      state.authParameterAchievementRatio.consumptionAchievementRatio = data / 100
    },
    setRechargeAchievementRatio (state, data) {
      state.authParameterAchievementRatio.rechargeAchievementRatio = data / 100
    },
    setSellAchievementRatio (state, data) {
      state.authParameterAchievementRatio.sellAchievementRatio = data / 100
    },
    setTreatmentAchievementRatio (state, data) {
      state.authParameterAchievementRatio.treatmentAchievementRatio = data / 100
    },
    setConsumptionRerecordDate (state, data) {
      state.authParameterRerecordDate.consumptionRerecordDate = data
    },
    setRechargeRerecordDate (state, data) {
      state.authParameterRerecordDate.rechargeRerecordDate = data
    },
    setSellRerecordDate (state, data) {
      state.authParameterRerecordDate.sellRerecordDate = data
    },
    setTreatmentRerecordDate (state, data) {
      state.authParameterRerecordDate.treatmentRerecordDate = data
    },
    setTreatmentRetreatRerecordDate (state, data) {
      state.authParameterRerecordDate.treatmentRetreatRerecordDate = data
    },
    setRechargeGiveCardDate (state, data) {
      state.authParameterGiveCardDate.rechargeGiveCardDate = data
    },
    setSellGiveCardDate (state, data) {
      state.authParameterGiveCardDate.sellGiveCardDate = data
    },
    setAuthParameterVipUpdateDate (state, data) {
      state.authParameterVipUpdateDate = data
    },
    setAuthSellOrder (state, data) {
      state.authSellOrder[data] = true
    },
    setAuthRechargeOrder (state, data) {
      state.authRechargeOrder[data] = true
    },
    setAuthConsumptionOrder (state, data) {
      state.authConsumptionOrder[data] = true
    },
    setAuthTreatmentOrder (state, data) {
      state.authTreatmentOrder[data] = true
    },
    setAuthTreatmentRetreatOrder (state, data) {
      state.authTreatmentRetreatOrder[data] = true
    },
    setResetAuthObj (state, data) {
      state[data.str] = data.obj
    },
    setauthMemberCardShowPhone (state, data) {
      state.authMemberCardShowPhone[data] = true
    },
    setauthMemberShowPhone (state, data) {
      state.authMemberShowPhone[data] = true
    },
    setauthMemberAnalysisShowPhone (state, data) {
      state.authMemberAnalysisShowPhone[data] = true
    }
  },
  actions: {
    // 获取用户参数列表
    getAuthUserParam () {
      let vm = this
      let data = {
        userId: session.get('userId'),
        roleId: session.get('roleId'),
        token: localRead('token'),
        platformType: 13001
      }
      let userParamList = getAuthUserParam(new Vue(), data)
      userParamList.then(function (result) {
        if (result !== null || result.paramList.size() > 0) {
          result.paramList.forEach((item) => {
            switch (item.paramCode) {
              case 'updateConsumptionPaymentDate':
                vm.commit('setUpdateConsumptionPaymentDate', item.paramValue)
                break
              case 'updateRechargePaymentDate':
                vm.commit('setUpdateRechargePaymentDate', item.paramValue)
                break
              case 'updateSellPaymentDate':
                vm.commit('setUpdateSellPaymentDate', item.paramValue)
                break
              case 'updateTreatmentPaymentDate':
                vm.commit('setUpdateTreatmentPaymentDate', item.paramValue)
                break
              case 'updateTreatmentRetreatPaymentDate':
                vm.commit('setUpdateTreatmentRetreatPaymentDate', item.paramValue)
                break
              case 'updateConsumptionPersonDate':
                vm.commit('setUpdateConsumptionPersonDate', item.paramValue)
                break
              case 'updateRechargePersonDate':
                vm.commit('setUpdateRechargePersonDate', item.paramValue)
                break
              case 'updateSellPersonDate':
                vm.commit('setUpdateSellPersonDate', item.paramValue)
                break
              case 'updateTreatmentPersonDate':
                vm.commit('setUpdateTreatmentPersonDate', item.paramValue)
                break
              case 'searchConsumptionDate':
                vm.commit('setSearchConsumptionDate', item.paramValue)
                break
              case 'searchRechargeDate':
                vm.commit('setSearchRechargeDate', item.paramValue)
                break
              case 'searchSellDate':
                vm.commit('setSearchSellDate', item.paramValue)
                break
              case 'searchTreatmentDate':
                vm.commit('setSearchTreatmentDate', item.paramValue)
                break
              case 'searchTreatmentRetreatDate':
                vm.commit('setSearchTreatmentRetreatDate', item.paramValue)
                break
              case 'consumptionAchievementRatio':
                vm.commit('setConsumptionAchievementRatio', item.paramValue)
                break
              case 'rechargeAchievementRatio':
                vm.commit('setRechargeAchievementRatio', item.paramValue)
                break
              case 'sellAchievementRatio':
                vm.commit('setSellAchievementRatio', item.paramValue)
                break
              case 'treatmentAchievementRatio':
                vm.commit('setTreatmentAchievementRatio', item.paramValue)
                break
              case 'consumptionRerecordDate':
                vm.commit('setConsumptionRerecordDate', item.paramValue)
                break
              case 'rechargeRerecordDate':
                vm.commit('setRechargeRerecordDate', item.paramValue)
                break
              case 'sellRerecordDate':
                vm.commit('setSellRerecordDate', item.paramValue)
                break
              case 'treatmentRerecordDate':
                vm.commit('setTreatmentRerecordDate', item.paramValue)
                break
              case 'treatmentRetreatRerecordDate':
                vm.commit('setTreatmentRetreatRerecordDate', item.paramValue)
                break
              case 'rechargeGiveCardDate':
                vm.commit('setRechargeGiveCardDate', item.paramValue)
                break
              case 'sellGiveCardDate':
                vm.commit('setSellGiveCardDate', item.paramValue)
                break
              case 'authParameterVipUpdateDate':
                vm.commit('setAuthParameterVipUpdateDate', item.paramValue)
                break
              default:
                break
            }
          })
        }
      })
    },
    // 设置字段、逻辑参数
    setAuthFieldParam (userAuthList) {
      // console.log(this.$store)
    },
    resetAuthObj (state, obj) {
      let vm = this
      let arr = Object.keys(obj)
      arr.map((item) => {
        vm.commit('setResetAuthObj', { obj: obj[item], str: item })
      })
    }
  }
}
